import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { ListItemIcon, MenuItem } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import { Tooltip } from "@material-ui/core";
import reactDom from "react-dom";

const useStyles = makeStyles({
  menuItem: {
    padding: "20px",
    justifyContent: "center",
  },
  itemIcon: {
    color: "white",
    justifyContent: "center",
  },
});

export default function NavBarItem(props) {
  const classes = useStyles();

  if (props.route === null) {
    return (
      <div>
        <Tooltip arrow placement="right" title={props.tooltipText}>
          <MenuItem
            onClick={props.clickEvent}
            className={classes.menuItem}
            selected={props.menuIndex === props.currentMenuSelection}
          >
            <ListItemIcon className={classes.itemIcon}>{props.icon}</ListItemIcon>
          </MenuItem>
        </Tooltip>
        {reactDom.createPortal(props.children, document.createElement("div"))}
      </div>
    );
  } else {
    return (
      <NavLink to={props.route}>
        <Tooltip arrow placement="right" title={props.tooltipText}>
          <MenuItem
            onClick={props.clickEvent}
            className={classes.menuItem}
            selected={props.menuIndex === props.currentMenuSelection}
          >
            <ListItemIcon className={classes.itemIcon}>{props.icon}</ListItemIcon>
          </MenuItem>
        </Tooltip>
      </NavLink>
    );
  }
}
